import { createContentSection } from "../content-section/content-section";
import { createFaq } from "../faq/faq";

export const createSectionSupport = () => {
  createContentSection();
  createFaq();
};
